import React, { useState } from 'react';
import './UploadJD.css';
import Navbar from '../About/Navbar';
import Footer from '../About/Footer';
import UploadPopup from './UploadDialog';
import { useNavigate } from 'react-router-dom';

function UploadJobDescription() {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  // ✅ Toggle dropdown visibility
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  // Handle file selection
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file before uploading.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await fetch("/api/upload_jd", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "File upload failed.");
      }

      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        navigate('/afterjd', { state: { jdData: data.job_details } });
      }, 2000);
    } catch (error) {
      alert(`Upload failed: ${error.message}`);
      console.error("Error uploading file:", error);
    }
  };
  return (
    <>
      <Navbar />
      <div className="main-content">

        <div className="welcome-section-v2">
          <h1>Hello, welcome to NewGenAlpha</h1>

          {/* ✅ Post Job Button with Dropdown */}
          <div className="post-job-dropdown">
            <button className="post-job-btn-v2" onClick={toggleDropdown}>Post Job ▾</button>

            {showDropdown && (
              <div className="dropdown-menu">
                <button className="dropdown-item" onClick={() => navigate('/jd')}>
                  Create JD
                </button>
                <button className="dropdown-item" onClick={() => navigate('')}>
                  Generate JD with AI
                </button>
                <button className="dropdown-item" onClick={() => navigate('/uploadjd')}>
                  Upload JD
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="content-section-v2">
          <div className="content-wrapper-v2">
            <div className="upload-section-v2">
              <div className="upload-container-v2">
                <div className="upload-box-v2">
                  <div className="upload-heading-v2">Upload</div>
                  <div className="upload-area-v2">
                    <span className="text-bold">Drag & drop files</span>
                    <input
                      type="file"
                      className="file-input"
                      onChange={handleFileChange}
                      accept=".pdf,.doc,.docx,.txt"
                    />
                    {selectedFile && (
                      <p className="file-name">Selected File: {selectedFile.name}</p>
                    )}
                  </div>
                  <button className="upload-btn-v2" onClick={handleUpload}>Upload JD</button>
                </div>
              </div>
            </div>
            {showSuccess && (
              <div className="modal-overlay">
                <div className="popup-success-container">
                  <div className="success-icon">✔</div>
                  <h2>Success</h2>
                  <p>Job Description uploaded successfully!</p>
                </div>
              </div>
            )}


            <div className="description-section-v2">
              <div className="description-container-v2">
                <div className="description-content-v2">
                  <div className="description-header-v2">
                    <h1 className="description-title-v2">
                      Craft a Compelling Job Description to Attract Top Talent
                    </h1>
                    <p className="description-summary-v2">
                      <span className="text-bold-v2">Summary:</span>
                      <br />
                      A well-structured job description helps attract the best-fit candidates by clearly outlining responsibilities, required skills, company values, and hiring expectations.
                    </p>
                  </div>

                  <div className="description-points-v2">
                    <ul>
                      <li>
                        <span className="text-bold-v2">Job Details:</span> Define job title, type, location, experience level, salary, and employment type.
                      </li>
                      <li>
                        <span className="text-bold-v2">Qualifications & Summary:</span> Highlight preferred qualifications and provide an engaging job overview.
                      </li>
                      <li>
                        <span className="text-bold-v2">Responsibilities & Skills:</span> List key responsibilities, required skills, and desired proficiencies.
                      </li>
                      <li>
                        <span className="text-bold-v2">Work & Culture Details (Optional):</span> Share insights into the company's culture, perks, and expectations.
                      </li>
                      <li>
                        <span className="text-bold-v2">Hiring Process & Engagement:</span> Set application deadlines, hiring stages, and expected engagement levels.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="description-footer-v2">
                  Start building your job description now!
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <Footer />

    </>
  );
}

export default UploadJobDescription;
